import { injectIntl } from "react-intl";
import { formatNumber } from "src/helpers/formatNumber";

const TABLE_COLUMNS = [
  { key: "date", label: "DATE", align: "left" },
  { key: "list", label: "LIST", align: "left" },
  { key: "offer", label: "OFFER", align: "left" },
  { key: "segment", label: "SEGMENT", align: "left" },
  { key: "messages", label: "MESSAGES", align: "right" },
  { key: "clicks", label: "CLICKS", align: "right" },
  { key: "conversions", label: "CONV", align: "right" },
  { key: "ctr", label: "CTR", align: "right" },
  { key: "convRate", label: "CONV RATE", align: "right" },
];

const TopCampaignsByClicks = ({ data = [] }) => {
  const renderCell = (item, column) => {
    switch (column.key) {
      case "date":
        return (
          <span className="SmsAnalyticsCampaignsDate">{item.date}</span>
        );
      case "list":
        return (
          <span className="SmsAnalyticsCampaignsList">{item.list}</span>
        );
      case "offer":
        return (
          <span className="SmsAnalyticsCampaignsOffer">{item.offer}</span>
        );
      case "segment":
        return (
          <span className="SmsAnalyticsCampaignsSegment">{item.segment}</span>
        );
      case "messages":
        return (
          <span className="SmsAnalyticsCampaignsNumber">
            {formatNumber(item.messages)}
          </span>
        );
      case "clicks":
        return (
          <span className="SmsAnalyticsCampaignsClicks">
            {formatNumber(item.clicks)}
          </span>
        );
      case "conversions":
        return (
          <span className="SmsAnalyticsCampaignsNumber">
            {formatNumber(item.conversions)}
          </span>
        );
      case "ctr":
        return (
          <span className="SmsAnalyticsCampaignsCTR">
            {formatNumber(item.ctr)}%
          </span>
        );
      case "convRate":
        return (
          <span className="SmsAnalyticsCampaignsNumber">
            {formatNumber(item.convRate)}%
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <div className="SmsAnalyticsChartCard SmsAnalyticsChartCardFull">
      <div className="SmsAnalyticsChartTitle">Top Campaigns by Clicks</div>
      <div className="SmsAnalyticsCampaignsTable">
        <div className="SmsAnalyticsCampaignsHeader">
          {TABLE_COLUMNS.map((column) => (
            <div
              key={column.key}
              className={`SmsAnalyticsCampaignsHeaderCell SmsAnalyticsCampaignsCell--${column.align}`}
            >
              {column.label}
            </div>
          ))}
        </div>
        {data.map((item, index) => (
          <div key={index} className="SmsAnalyticsCampaignsRow">
            {TABLE_COLUMNS.map((column) => (
              <div
                key={column.key}
                className={`SmsAnalyticsCampaignsCell SmsAnalyticsCampaignsCell--${column.align}`}
              >
                {renderCell(item, column)}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default injectIntl(TopCampaignsByClicks);
